export default __webpack_public_path__ + "static/media/home_video.ab0a85c2.mov";